const ptRound = (pt: number) => pt.toFixed().replace('.00', '');

export default ptRound;
